import { getOnline, setOnline } from "store/storeValtio";

const apiURL = 'https://api.itookitwhen.com';

export function checkOnline() {
  const ol = window.navigator.onLine;
  if (ol !== getOnline()) {
    setOnline(ol);
    console.log("online: ", ol)
  }
  return ol;
}

export async function postAPI(url, json) {
  const jsonString = (typeof json !== 'object') ? json : JSON.stringify(json) ;
  //console.log('postDataAPI', jsonString);
  const message = {
    method: 'POST', 
    mode: 'cors', 
    headers: {"Content-Type": "application/json"},
    body: jsonString
    };
    
  let response =  await fetch(apiURL + url, message);
  //console.log("postDataAPI response:", response);
  return response;
}

export async function getAPI(url) {
  console.log('getDataAPI', url);
  const response =  await fetch(apiURL + url, {
    method: 'GET', 
    cache: "no-store",
    mode: 'cors', 
    headers: {"Content-Type": "application/json"},
    });

  if (!response.ok) {
    console.log("getAPI: ", response)
    return null;
    // throw new Error(
    //   `Request failed for ${url}: ${response.status}`
    // );
  }

  const data = await response.json();
  //console.log('getAPI data:', data);
  return data;
}

export async function sendEmailText(emailTo, content)
{
  const message = {
    email: emailTo,
    message: content
  }
  
  const url = 'sendEmailText';
  let result = await postAPI(url, message)
  console.log('sendEmailText: ', result);
  return result;
}

export async function getJson(url) {
  const response = await fetch(url)

  if (!response.ok) {
    console.log(response)
    throw new Error(
      `Request failed for ${url}: ${response.status}`
    );
  }

  return await response.json();
}

